<div id="deviceLogCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@devicelog_title">Registro dati</ng-container>
  </div>

  <div>

    <mat-tab-group [animationDuration]="'0ms'">

      <mat-tab label={{deviceLogString}}>

        <div fxLayout="row" fxLayoutAlign="start center" style="margin-top:30px">

          <div fxFlex="2">
          </div>

      
          <div id="radiobuttons-div" fxFlex="55">
            <mat-radio-group id="radiobuttons">
              <mat-radio-button class="mat-radio-button" value="1" i18n="@@devicelog_today" (change)="setLogTimeRange($event)"
                [checked]="true">Oggi
              </mat-radio-button>
              <mat-radio-button class="mat-radio-button" value="2" (change)="setLogTimeRange($event)"
                i18n="@@devicelog_yesterday">Ieri
              </mat-radio-button>
              <mat-radio-button class="mat-radio-button-custom" value="3" (change)="setLogTimeRange($event)"
                i18n="@@devicelog_custom">
                Personalizzato</mat-radio-button>
            </mat-radio-group>
          </div>
      
          <div fxFlex="10">
            <button (click)="refreshData()" mat-mini-fab>
              <fa-icon id="refesh-data-icon" icon="redo"></fa-icon>
            </button>
          </div>
      
          <div fxFlex="5">
            <p style="margin-top:8px" i18n="@@accesslog_filter">Filtra:</p>
          </div>
      
          <div fxFlex="25" class="table-filter">
            <input id="filter-input" (keyup)="onKey($event)" />
          </div>
      
          <div fxFlex>
          </div>
        </div>

        <!-- <div id="radiobuttons-div">
          <mat-radio-group id="radiobuttons">
            <mat-radio-button class="mat-radio-button" value="1" i18n="@@devicelog_today" (change)="setLogTimeRange($event)" [checked]="true">Oggi
            </mat-radio-button>
            <mat-radio-button class="mat-radio-button" value="2" (change)="setLogTimeRange($event)" i18n="@@devicelog_yesterday">Ieri
            </mat-radio-button>
            <mat-radio-button class="mat-radio-button" value="3" (change)="setLogTimeRange($event)" i18n="@@devicelog_custom">
              Personalizzato</mat-radio-button>
          </mat-radio-group>
        </div>

        <div id="table-filter-container">
          <div class="table-filter">
            <input id="filter-input" (keyup)="onKey($event)" />
            <p i18n="@@devicelog_filter">Filtra: </p>

          </div>
        </div> -->


        <br clear="all">
        <br>
        <div id="datepickers-div" *ngIf="showDatePickers">

          <div id="from-datepicker-div">
            <p class="text-small text-dark" i18n="@@devicelog_start_date">
              Data di inizio:
            </p>
            <input id="from-datepicker-input" [matDatepicker]="fromDatepicker" [formControl]="fromFormControl">
            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatepicker></mat-datepicker>
          </div>
          <div id="to-datepicker-div">
            <p class="text-small text-dark" i18n="@@devicelog_end_date">
              Data di fine:
            </p>
            <input id="to-datepicker-input" [matDatepicker]="toDatepicker" [formControl]="toFormControl">
            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatepicker></mat-datepicker>
          </div>
          <div id="confirm-button-div">
            <a id="confirmButton" class="button" (click)="confirmDateSelection()">
              <ng-container i18n="@@devicelog_confirm">Conferma</ng-container> <span>
                <fa-icon icon="check"></fa-icon>
              </span>
            </a>
          </div>
        </div>

        <br clear="all" />

        <div class="control-card-content">

          <mat-paginator (page)="changePage($event)" [pageIndex]="currentPage" [length]="tableItemsTotalCounter" [pageSizeOptions]="pageSizeOptions">
          </mat-paginator>


          <div class="table-container" id="device-log-wrapper">

            <table mat-table matSort #logtable class="simple-table">

              <!-- <ng-container matColumnDef="type">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelog_type">type</th>
                   <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@userslist_name" style="width: 45%;">Nome</th>
                <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
              </ng-container> -->

              <ng-container matColumnDef="date">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelog_date" style="width: 21%">Data
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.dateFriendly }} </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelog_name" style="width: 25%">Nome
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
              </ng-container>

              <ng-container matColumnDef="data">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@devicelog_data" style="width: 25%">data
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.data }} </td>
              </ng-container>

              <ng-container matColumnDef="event">
                <th mat-header-cell *matHeaderCellDef i18n="@@devicelog_event" style="width: 15%">Evento</th>
                <td mat-cell *matCellDef="let element" class="date-text">
                  <fa-icon icon="{{ element.getIcon() }}" class="margin-right-5"></fa-icon>
                  {{ element.dataType }}
                </td>
              </ng-container>

              <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef i18n="@@devicelog_active">Stato</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.eventType == 'value'">{{element.value}} </ng-container>
                  <ng-container *ngIf="element.eventType == 'bool' && element.dataActive" i18n="@@devicelog_activated"> Attivato</ng-container>
                  <ng-container *ngIf="element.eventType == 'bool' && !element.dataActive" i18n="@@devicelog_deactivated">Disattivato</ng-container>
                  <ng-container *ngIf="element.eventType == 'completed'" i18n="@@devicelog_completed">Completato</ng-container>
                  <ng-container *ngIf="element.eventType == 'event' " i18n="@@devicelog_event">Evento</ng-container>
                  <ng-container *ngIf="element.eventType == 'alarm' " i18n="@@devicelog_alarm">Allarme</ng-container>

                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)" [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
              </tr>

            </table>
          </div>

        </div>
      </mat-tab>

      <mat-tab label={{accessLogString}}>
        <app-access-log *ngIf="device" [device]="device"> </app-access-log>
      </mat-tab>


      <mat-tab label={{automationsLogString}}>
        <app-automations-log *ngIf="device" [device]="device"> </app-automations-log>
      </mat-tab>


    </mat-tab-group>
  </div>

  <app-loading-screen #logloader></app-loading-screen>

</div>